import { ErrorObject } from '../view/types/types';

const noError: ErrorObject = {
  hasError: false,
  message: ''
};

function required(value: string): ErrorObject {
  if (value.length > 0) return { ...noError };
  return {
    hasError: true,
    message: 'Este campo es requerido'
  };
}

function length(value: string, payload: { length: number }): ErrorObject {
  if (value.length === payload.length) return { ...noError };
  return {
    hasError: true,
    message: `Debe ser un valor de ${payload.length} caracteres`
  };
}

function isNumber(value: string): ErrorObject {
  const pattern = /^\d+$/;
  if (pattern.test(value)) return { ...noError };
  return {
    hasError: true,
    message: 'Este campo debe ser un valor numérico.'
  };
}

const ValidationTypes = {
  required,
  length,
  number: isNumber
};
export type Validations = keyof typeof ValidationTypes;

export function Validator(value: string, validations: Validations[], payload?: any): ErrorObject {
  let data: ErrorObject = { ...noError };
  // eslint-disable-next-line no-restricted-syntax
  for (const validation of validations) {
    data = ValidationTypes[validation](value, payload);
    if (data.hasError) break;
  }
  return data;
}
